import { TanstackDatabaseCollections } from "@/domains/tanstack-db/core/collections";
import { SmartContextRepository } from "./smart-contexts";
import { SmartViewRepository } from "./smart-views";
import { SmartCardRepository } from "./smart-cards";
import { StatsRepository } from "./stats";

export interface TanstackRepositorySet {
  smartContexts: SmartContextRepository;
  smartViews: SmartViewRepository;
  smartCards: SmartCardRepository;
  stats: StatsRepository;
}

export const createRepositories = ({
  smartContexts,
  smartViews,
  smartCards,
}: TanstackDatabaseCollections): TanstackRepositorySet => ({
  smartContexts: new SmartContextRepository({
    collection: smartContexts,
  }),
  smartViews: new SmartViewRepository({
    collection: smartViews,
  }),
  smartCards: new SmartCardRepository({
    collection: smartCards,
  }),
  stats: new StatsRepository({ collections: { smartContexts, smartViews, smartCards } }),
});
